// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2Mhs2","footer":"ModalError_footer__dCU9f"};